{
  "title": "Title",
  "title_placeholder": "Title of the shot",
  "description": "Description",
  "location": "Location",
  "select_location": "Select or add location",
  "timing": "Timing",
  "directors_note": "Directors note",
  "src": "src",
  "order": "Order",
  "shooting_day": "Shooting day",
  "scene": "Scene",
  "select_scene": "Select scene",
  "shot_submit": "Add shot",
  "shot_update": "Update shot",
  "field_required": "This field is required",
  "no_image": "Image is not available",
  "add_shot": "Add shot",
  "update_shot": "Update shot",
  "voice_over": "Voice over",
  "delete_shot": "Are you sure you want to delete this shot ?",
  "shot_size": "Shot size",
  "shot_type": "Shot type",
  "movement": "Movement",
  "add_shootingDay": "Add shooting day",
  "select_shooting_day": "Select shooting day",
  "select_shot_size": "Select shooting size",
  "select_shot_type": "Select shot type",
  "insert_before": "Insert before",
  "insert_after": "Insert after",
  "angle": "Angle",
  "lens": "Camera lens",
  "lens_placeholder": "Camera lens needed for the shot",
  "estimated_time": "Estimated time (in min)",
  "estimated_time_placeholder": "Estimated time (in min)",
  "fps": "FPS",
  "light": "Light",
  "light_placeholder": "Light needed for the shot",
  "props": "Props",

  "aerial": "Aerial",
  "eye_level": "Eye level",
  "low_angle": "Low angle",
  "high_angle": "High angle",
  "overhead": "Overhead",
  "shoulder_level": "Shoulder level",
  "hip_level": "Hip level",
  "knee_level": "Knee level",
  "ground_level": "Ground level",

  "static": "Static",
  "pan": "Pan",
  "tilt": "Tilt",
  "swish_pan": "Swish pan",
  "swish_tilt": "Swish tilt",
  "tracking": "Tracking",
  "custom": "Custom",

  "error_shot": "An error has occurred while displaying the shot",
  "image_dimensions_error": "The dimensions of this image are to big, Max dimensions:",

  "EST": "Establish",
  "MA": "Master",
  "XW": "Extreme Wide",
  "WID": "Wide",
  "FUL": "Full",
  "MED": "Medium",
  "MCU": "Medium Close-up",
  "CU": "Close-up",
  "ECU": "Extreme Close-up",
  "MAC": "Macro",

  "XLS": "Extreme long shot",
  "LS": "Long shot",
  "MLS": "Medium long shot",
  "MS": "Mid Shot",
  "BCU": "Big Close-up"
}
